import { makeGetCall, XHRResponseType } from 'frontend/core/src/data/util';
import { hostUrl } from 'frontend/core/src/utils/getServerUrl';

import { SapMeteringInfo } from './apiTypes';

export const getSapMeteringInfo = (): XHRResponseType<SapMeteringInfo> =>
  makeGetCall(`${hostUrl}/athena/api/v1/metering`);
